/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NexonAnalyticsGeneralChartListInfo } from '../models/NexonAnalyticsGeneralChartListInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class EvmAnalyticsControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns NexonAnalyticsGeneralChartListInfo OK
     * @throws ApiError
     */
    public getAnalyticsMsuTotalUsers({
        period = 'M6',
        from,
        to,
    }: {
        period?: 'D7' | 'M1' | 'M6' | 'YTD' | 'Y1' | 'ALL',
        from?: string,
        to?: string,
    }): CancelablePromise<NexonAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/analytics/user/total/users',
            query: {
                'period': period,
                'from': from,
                'to': to,
            },
        });
    }

    /**
     * @returns NexonAnalyticsGeneralChartListInfo OK
     * @throws ApiError
     */
    public getAnalyticsMsuTotalUsers1({
        period = 'M6',
        from,
        to,
    }: {
        period?: 'D7' | 'M1' | 'M6' | 'YTD' | 'Y1' | 'ALL',
        from?: string,
        to?: string,
    }): CancelablePromise<NexonAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/analytics/user/total/users',
            query: {
                'period': period,
                'from': from,
                'to': to,
            },
        });
    }

    /**
     * @returns NexonAnalyticsGeneralChartListInfo OK
     * @throws ApiError
     */
    public getEvmAnalyticsUserStickiness({
        period = 'M6',
        from,
        to,
    }: {
        period?: 'D7' | 'M1' | 'M6' | 'YTD' | 'Y1' | 'ALL',
        from?: string,
        to?: string,
    }): CancelablePromise<NexonAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/analytics/user/stickiness',
            query: {
                'period': period,
                'from': from,
                'to': to,
            },
        });
    }

    /**
     * @returns NexonAnalyticsGeneralChartListInfo OK
     * @throws ApiError
     */
    public getEvmAnalyticsUserStickiness1({
        period = 'M6',
        from,
        to,
    }: {
        period?: 'D7' | 'M1' | 'M6' | 'YTD' | 'Y1' | 'ALL',
        from?: string,
        to?: string,
    }): CancelablePromise<NexonAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/analytics/user/stickiness',
            query: {
                'period': period,
                'from': from,
                'to': to,
            },
        });
    }

    /**
     * @returns NexonAnalyticsGeneralChartListInfo OK
     * @throws ApiError
     */
    public getEvmAnalyticsRetentionRate({
        to,
    }: {
        to?: string,
    }): CancelablePromise<NexonAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/analytics/user/retention/rate',
            query: {
                'to': to,
            },
        });
    }

    /**
     * @returns NexonAnalyticsGeneralChartListInfo OK
     * @throws ApiError
     */
    public getEvmAnalyticsRetentionRate1({
        to,
    }: {
        to?: string,
    }): CancelablePromise<NexonAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/analytics/user/retention/rate',
            query: {
                'to': to,
            },
        });
    }

    /**
     * @returns NexonAnalyticsGeneralChartListInfo OK
     * @throws ApiError
     */
    public getEvmAnalyticsUserStickiness2({
        period = 'M6',
        from,
        to,
    }: {
        period?: 'D7' | 'M1' | 'M6' | 'YTD' | 'Y1' | 'ALL',
        from?: string,
        to?: string,
    }): CancelablePromise<NexonAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/analytics/user/new/registered',
            query: {
                'period': period,
                'from': from,
                'to': to,
            },
        });
    }

    /**
     * @returns NexonAnalyticsGeneralChartListInfo OK
     * @throws ApiError
     */
    public getEvmAnalyticsUserStickiness3({
        period = 'M6',
        from,
        to,
    }: {
        period?: 'D7' | 'M1' | 'M6' | 'YTD' | 'Y1' | 'ALL',
        from?: string,
        to?: string,
    }): CancelablePromise<NexonAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/analytics/user/new/registered',
            query: {
                'period': period,
                'from': from,
                'to': to,
            },
        });
    }

    /**
     * @returns NexonAnalyticsGeneralChartListInfo OK
     * @throws ApiError
     */
    public getEvmAnalyticsMsuUniqueActiveWallets({
        period = 'M6',
        interval = 'DAY',
        from,
        to,
    }: {
        period?: 'D7' | 'M1' | 'M6' | 'YTD' | 'Y1' | 'ALL',
        interval?: 'DAY' | 'WEEK' | 'MONTH' | 'QUARTER',
        from?: string,
        to?: string,
    }): CancelablePromise<NexonAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/analytics/user/msu/uaw',
            query: {
                'period': period,
                'interval': interval,
                'from': from,
                'to': to,
            },
        });
    }

    /**
     * @returns NexonAnalyticsGeneralChartListInfo OK
     * @throws ApiError
     */
    public getEvmAnalyticsMsuUniqueActiveWallets1({
        period = 'M6',
        interval = 'DAY',
        from,
        to,
    }: {
        period?: 'D7' | 'M1' | 'M6' | 'YTD' | 'Y1' | 'ALL',
        interval?: 'DAY' | 'WEEK' | 'MONTH' | 'QUARTER',
        from?: string,
        to?: string,
    }): CancelablePromise<NexonAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/analytics/user/msu/uaw',
            query: {
                'period': period,
                'interval': interval,
                'from': from,
                'to': to,
            },
        });
    }

    /**
     * @returns NexonAnalyticsGeneralChartListInfo OK
     * @throws ApiError
     */
    public getEvmAnalyticsUniqueActiveWallets({
        period = 'M6',
        from,
        to,
    }: {
        period?: 'D7' | 'M1' | 'M6' | 'YTD' | 'Y1' | 'ALL',
        from?: string,
        to?: string,
    }): CancelablePromise<NexonAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/analytics/user/msn/uaw',
            query: {
                'period': period,
                'from': from,
                'to': to,
            },
        });
    }

    /**
     * @returns NexonAnalyticsGeneralChartListInfo OK
     * @throws ApiError
     */
    public getEvmAnalyticsUniqueActiveWallets1({
        period = 'M6',
        from,
        to,
    }: {
        period?: 'D7' | 'M1' | 'M6' | 'YTD' | 'Y1' | 'ALL',
        from?: string,
        to?: string,
    }): CancelablePromise<NexonAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/analytics/user/msn/uaw',
            query: {
                'period': period,
                'from': from,
                'to': to,
            },
        });
    }

    /**
     * @returns NexonAnalyticsGeneralChartListInfo OK
     * @throws ApiError
     */
    public getEvmAnalyticsMsnUniqueActiveAddress({
        period = 'M6',
        from,
        to,
    }: {
        period?: 'D7' | 'M1' | 'M6' | 'YTD' | 'Y1' | 'ALL',
        from?: string,
        to?: string,
    }): CancelablePromise<NexonAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/analytics/user/msn/uaa',
            query: {
                'period': period,
                'from': from,
                'to': to,
            },
        });
    }

    /**
     * @returns NexonAnalyticsGeneralChartListInfo OK
     * @throws ApiError
     */
    public getEvmAnalyticsMsnUniqueActiveAddress1({
        period = 'M6',
        from,
        to,
    }: {
        period?: 'D7' | 'M1' | 'M6' | 'YTD' | 'Y1' | 'ALL',
        from?: string,
        to?: string,
    }): CancelablePromise<NexonAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/analytics/user/msn/uaa',
            query: {
                'period': period,
                'from': from,
                'to': to,
            },
        });
    }

    /**
     * @returns NexonAnalyticsGeneralChartListInfo OK
     * @throws ApiError
     */
    public getEvmAnalyticsNxpcHolder({
        period = 'M6',
        from,
        to,
    }: {
        period?: 'D7' | 'M1' | 'M6' | 'YTD' | 'Y1' | 'ALL',
        from?: string,
        to?: string,
    }): CancelablePromise<NexonAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/analytics/token/nxpc/holder',
            query: {
                'period': period,
                'from': from,
                'to': to,
            },
        });
    }

    /**
     * @returns NexonAnalyticsGeneralChartListInfo OK
     * @throws ApiError
     */
    public getEvmAnalyticsNxpcHolder1({
        period = 'M6',
        from,
        to,
    }: {
        period?: 'D7' | 'M1' | 'M6' | 'YTD' | 'Y1' | 'ALL',
        from?: string,
        to?: string,
    }): CancelablePromise<NexonAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/analytics/token/nxpc/holder',
            query: {
                'period': period,
                'from': from,
                'to': to,
            },
        });
    }

    /**
     * @returns NexonAnalyticsGeneralChartListInfo OK
     * @throws ApiError
     */
    public getEvmAnalyticsNftHolder({
        period = 'M6',
        from,
        to,
    }: {
        period?: 'D7' | 'M1' | 'M6' | 'YTD' | 'Y1' | 'ALL',
        from?: string,
        to?: string,
    }): CancelablePromise<NexonAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/analytics/token/nft/holder',
            query: {
                'period': period,
                'from': from,
                'to': to,
            },
        });
    }

    /**
     * @returns NexonAnalyticsGeneralChartListInfo OK
     * @throws ApiError
     */
    public getEvmAnalyticsNftHolder1({
        period = 'M6',
        from,
        to,
    }: {
        period?: 'D7' | 'M1' | 'M6' | 'YTD' | 'Y1' | 'ALL',
        from?: string,
        to?: string,
    }): CancelablePromise<NexonAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/analytics/token/nft/holder',
            query: {
                'period': period,
                'from': from,
                'to': to,
            },
        });
    }

    /**
     * @returns NexonAnalyticsGeneralChartListInfo OK
     * @throws ApiError
     */
    public getEvmAnalyticsNesoHolder({
        period = 'M6',
        from,
        to,
    }: {
        period?: 'D7' | 'M1' | 'M6' | 'YTD' | 'Y1' | 'ALL',
        from?: string,
        to?: string,
    }): CancelablePromise<NexonAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/analytics/token/neso/holder',
            query: {
                'period': period,
                'from': from,
                'to': to,
            },
        });
    }

    /**
     * @returns NexonAnalyticsGeneralChartListInfo OK
     * @throws ApiError
     */
    public getEvmAnalyticsNesoHolder1({
        period = 'M6',
        from,
        to,
    }: {
        period?: 'D7' | 'M1' | 'M6' | 'YTD' | 'Y1' | 'ALL',
        from?: string,
        to?: string,
    }): CancelablePromise<NexonAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/analytics/token/neso/holder',
            query: {
                'period': period,
                'from': from,
                'to': to,
            },
        });
    }

    /**
     * @returns NexonAnalyticsGeneralChartListInfo OK
     * @throws ApiError
     */
    public getEvmAnalyticsTrxCount({
        period = 'M6',
        from,
        to,
    }: {
        period?: 'D7' | 'M1' | 'M6' | 'YTD' | 'Y1' | 'ALL',
        from?: string,
        to?: string,
    }): CancelablePromise<NexonAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/analytics/network/transaction/count',
            query: {
                'period': period,
                'from': from,
                'to': to,
            },
        });
    }

    /**
     * @returns NexonAnalyticsGeneralChartListInfo OK
     * @throws ApiError
     */
    public getEvmAnalyticsTrxCount1({
        period = 'M6',
        from,
        to,
    }: {
        period?: 'D7' | 'M1' | 'M6' | 'YTD' | 'Y1' | 'ALL',
        from?: string,
        to?: string,
    }): CancelablePromise<NexonAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/analytics/network/transaction/count',
            query: {
                'period': period,
                'from': from,
                'to': to,
            },
        });
    }

    /**
     * @returns NexonAnalyticsGeneralChartListInfo OK
     * @throws ApiError
     */
    public getAnalyticsMarketplaceTraders({
        period = 'M6',
        from,
        to,
    }: {
        period?: 'D7' | 'M1' | 'M6' | 'YTD' | 'Y1' | 'ALL',
        from?: string,
        to?: string,
    }): CancelablePromise<NexonAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/analytics/marketplace/traders',
            query: {
                'period': period,
                'from': from,
                'to': to,
            },
        });
    }

    /**
     * @returns NexonAnalyticsGeneralChartListInfo OK
     * @throws ApiError
     */
    public getAnalyticsMarketplaceTraders1({
        period = 'M6',
        from,
        to,
    }: {
        period?: 'D7' | 'M1' | 'M6' | 'YTD' | 'Y1' | 'ALL',
        from?: string,
        to?: string,
    }): CancelablePromise<NexonAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/analytics/marketplace/traders',
            query: {
                'period': period,
                'from': from,
                'to': to,
            },
        });
    }

}
